import { render, staticRenderFns } from "./ParkinglotLists.vue?vue&type=template&id=374f51e2&"
import script from "./ParkinglotLists.vue?vue&type=script&lang=js&"
export * from "./ParkinglotLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ParkinglotLists.vue"
export default component.exports